const json2csv = require("json2csv").parse;
export default class exportJson {
  downloadCsv(json, name = 'leanlaw-export', header = true) {
    const filename = `${name}.csv`;
    // https://stackoverflow.com/questions/6672834/specifying-blob-encoding-in-google-chrome
    const BOM = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const blob = new Blob([BOM, json2csv(json, {
      header
    })], {
      type: "text/csv; charset=utf-8"
    });

    // The previous version of this only worked on macs not windows.
    // If updating, make sure to test not just in different browsers,
    // but also different platforms
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      if (link.download !== undefined) {
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.open(url);
      }
    }
  }
}